/* eslint-disable import/prefer-default-export */
import { useInfiniteQuery } from '@tanstack/react-query';

import {
  type RuleListRequestBody,
  type RuleListResponse,
  RulesService,
} from '../services/RulesService';

/**
 * Hook to fetch paginated and filtered list of rules with infinite scrolling support
 * Uses React Query's useInfiniteQuery for automatic pagination management
 * @param requestBody - Request body with filters (pagination is handled automatically)
 * @returns React Query infinite result with rules list data across all pages
 */
export const useInfiniteRules = (
  requestBody: Omit<RuleListRequestBody, 'pagination'> = {}
) =>
  useInfiniteQuery({
    queryKey: ['rules-infinite', requestBody],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      RulesService.getRulesList({
        ...requestBody,
        pagination: { max: 5, page: pageParam },
      }),
    getNextPageParam: (lastPage: RuleListResponse) =>
      lastPage.pagination.nextPage,
    initialPageParam: 1,
    retry: 1,
  });
